@if (outboundFax.inboundCalls.length > 0) {
  <div>
    Yes -
    <br />
    @for (inboundCall of outboundFax.inboundCalls; track inboundCall) {
      <div>
        {{ keyedInboundCallReasonOptions[inboundCall.reason].display }}:
        <a target="_blank" routerLink="/capture-admin/communications/inbound-calls/{{ inboundCall.id }}">
          {{ inboundCall.createdAt | date: 'M/d/yyyy' }}
        </a>
      </div>
    }
  </div>
} @else {
  No
}

